export default __webpack_public_path__ + "static/media/network.49d28996.svg";